import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Users, Mail, Plus, Trash2, Loader2, Search, UserPlus } from "lucide-react";
import { STATUS_OPTIONS, RELATIONSHIP_OPTIONS, itemLabel } from "./accountsModel";

export const AccountsHeader = ({ viewMode, hasBlank, cleaningUp, onCleanup, onAdd, onOutreach, onIntake }) => (
  <div className="flex items-center justify-between gap-4 flex-wrap">
    <div>
      <h1 className="text-2xl text-white mb-2 flex items-center gap-2">
        <Users className="h-6 w-6 text-ism-teal" />
        <span className="text-ism-teal">Accounts & Leads</span>
      </h1>
      <p className="text-sm text-gray-500">Current customers, wishlist targets and the people at each</p>
    </div>
    <div className="flex gap-2 flex-wrap">
      {viewMode === "accounts" && hasBlank && (
        <Button onClick={onCleanup} disabled={cleaningUp} variant="outline" className="border-red-400/30 text-red-400 hover:bg-red-400/10" data-testid="cleanup-blank-btn">
          {cleaningUp ? <Loader2 className="h-4 w-4 animate-spin mr-2" /> : <Trash2 className="h-4 w-4 mr-2" />}
          Remove Blank Accounts
        </Button>
      )}
      <Button onClick={onIntake} className="bg-ism-teal hover:bg-ism-teal/90 text-black font-medium" data-testid="open-intake-btn">
        <UserPlus className="h-4 w-4 mr-2" /> Add customers &amp; prospects
      </Button>
      <Button onClick={onAdd} variant="outline" className="border-white/20 text-gray-300 hover:bg-white/5" data-testid="add-item-btn">
        <Plus className="h-4 w-4 mr-2" /> Add {itemLabel(viewMode)}
      </Button>
      <Button onClick={onOutreach} variant="outline" className="border-white/20 text-gray-300 hover:bg-white/5" data-testid="bulk-outreach-btn">
        <Mail className="h-4 w-4 mr-2" /> Generate Outreach
      </Button>
    </div>
  </div>
);

const TOGGLE_ON = "bg-ism-teal/20 text-ism-teal hover:bg-ism-teal/30 border border-ism-teal/30";
const TOGGLE_OFF = "text-gray-400 hover:text-white hover:bg-white/10";

export const ViewToggle = ({ viewMode, setViewMode, accountsCount, leadsCount }) => (
  <div className="flex gap-2 glass-card-light p-1 rounded-lg w-fit">
    <Button variant={viewMode === "accounts" ? "default" : "ghost"} size="sm" onClick={() => setViewMode("accounts")} className={viewMode === "accounts" ? TOGGLE_ON : TOGGLE_OFF} data-testid="view-accounts-btn">
      Accounts ({accountsCount})
    </Button>
    <Button variant={viewMode === "leads" ? "default" : "ghost"} size="sm" onClick={() => setViewMode("leads")} className={viewMode === "leads" ? TOGGLE_ON : TOGGLE_OFF} data-testid="view-leads-btn">
      Leads ({leadsCount})
    </Button>
  </div>
);

export const AccountsFilters = ({ viewMode, search, setSearch, status, setStatus, relationship, setRelationship }) => (
  <div className="flex gap-4 flex-col sm:flex-row">
    <div className="flex-1 relative">
      <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-gray-500" />
      <Input value={search} onChange={(e) => setSearch(e.target.value)} placeholder={`Search ${viewMode}...`} className="pl-10 bg-white/5 border-white/10 text-white placeholder:text-gray-500" data-testid="search-accounts" />
    </div>
    <select value={relationship} onChange={(e) => setRelationship(e.target.value)} className="bg-white/5 border border-white/10 text-white rounded-lg px-4 py-2 text-sm" data-testid="relationship-filter">
      {RELATIONSHIP_OPTIONS.map(([value, label]) => <option key={value} value={value}>{label}</option>)}
    </select>
    <select value={status} onChange={(e) => setStatus(e.target.value)} className="bg-white/5 border border-white/10 text-white rounded-lg px-4 py-2 text-sm" data-testid="status-filter">
      {STATUS_OPTIONS.map(([value, label]) => <option key={value} value={value}>{label}</option>)}
    </select>
  </div>
);
